/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 4/10/2023
 */
import { useEffect } from "react"
import pkceChallenge from "pkce-challenge"
import { useNavigate } from "react-router-dom"

const baseURL = process.env.REACT_APP_BASE_URL

const Login = () => {
  const navigate = useNavigate()
  const isLoggedin = localStorage.getItem("isLoggedin")

  /*Function of generating code challenge, code verifier and load the Auth login page*/
  const loginAuth = async () => {
    const challenge = pkceChallenge(44)
    const codeVerifier = challenge.code_verifier //generate code verifier
    const codeChallenge = challenge.code_challenge //generate code challenge
    localStorage.setItem("codeVerifier", codeVerifier)

    const domain = process.env.REACT_APP_AUTH_API_URL
    const scope = "openid"
    const clientId = process.env.REACT_APP_AUTH_USERNAME
    const responseType = "code"
    const redirectUri = baseURL + "/loading"
    const code_challenge = codeChallenge
    const code_challenge_method = "S256"

    const response = await fetch(
      `${domain}/authorized?` +
        `scope=${scope}&` +
        `response_type=${responseType}&` +
        `client_id=${clientId}&` +
        `code_challenge=${code_challenge}&` +
        `code_challenge_method=${code_challenge_method}&` +
        `redirect_uri=${redirectUri}`,
      {
        redirect: "manual",
      }
    )

    window.location.replace(response.url)
  }

  useEffect(() => {
    if (isLoggedin === "true") {
      navigate("/app/dashboard")
    } else {
      loginAuth()
    }
  }, [])

  return null
}

export default Login
